module.exports = __webpack_public_path__ + "img/sinusalud.3b09fdcb.png";